import React from "react";

import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import AuditForm from "./AuditForm";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import AuditData from "./audit-data";

const Audit = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("AUDITOR_AUDIT", "AUDITOR_AUDIT");
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ADMIN")}
        subTitle={i18n.get("VIEW_ADMIN_EVENTS")}
        withRefresh={false}
        onPress={() => {
          getCorePopUpStore().showHelperMessage("Admin_Audit_Helper_Text");
        }}
        withHelper={true}
      />
      <AuditForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AuditData />
    </ET3PageDiv>
  );
});
export default Audit;
